import { render, staticRenderFns } from "./ordersInTransitShow.vue?vue&type=template&id=1240cb20&scoped=true"
import script from "./ordersInTransitShow.vue?vue&type=script&lang=js"
export * from "./ordersInTransitShow.vue?vue&type=script&lang=js"
import style0 from "./ordersInTransitShow.vue?vue&type=style&index=0&id=1240cb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240cb20",
  null
  
)

export default component.exports